import React from "react";

const NoBrokeragePage = () => {
  const features = [
    {
      title: "No Brokerage",
      description: "Free Services For Buyers & Tenants",
      icon: "/pricenegotiation.png",
    },
    {
      title: "Documentation",
      description: "Collection & Documentation Assistance",
      icon: "/searchProperties.png",
    },
    {
      title: "Free Site Visit",
      description: "Guided Property Tours",
      icon: "/sitevisits.png",
    },
    {
      title: "Agreement",
      description: "We help you in agreement procedure",
      icon: "/shortlist.png",
    },
  ];

  const impactStats = [
    {
      value: "₹100 Cr+",
      description: "Brokerage Saved Monthly",
      icon: "/deals.png",
    },
    {
      value: "25,000+",
      description: "New Listings Monthly",
      icon: "/shortlist.png",
    },
    {
      value: "50 Lacs+",
      description: "Customers Connected Monthly",
      icon: "/expert.png",
    },
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-4xl font-bold text-gray-800">
          India’s Best <span className="text-blue-600">No Brokerage Platform</span>
        </h1>
        <p className="text-gray-600 mt-3 text-lg">
          Awarded As The Largest Contributor in New Project Selling
        </p>
      </header>

      {/* Features Section */}
      <section className="my-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center text-center border-t-4 border-blue-500 hover:shadow-xl transition duration-300"
            >
              <img
                src={feature.icon}
                alt={feature.title}
                className="w-16 h-16 mb-4"
              />
              <h3 className="text-xl font-bold text-gray-800">{feature.title}</h3>
              <p className="text-gray-600 mt-2">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Impact Section */}
      <section className="my-12">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
          What’s The Impact?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {impactStats.map((stat, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center text-center border-t-4 border-blue-500 hover:shadow-xl transition duration-300"
            >
              <img
                src={stat.icon}
                alt={stat.description}
                className="w-16 h-16 mb-4"
              />
              <h3 className="text-3xl font-bold text-blue-600">{stat.value}</h3>
              <p className="text-gray-600 mt-2">{stat.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default NoBrokeragePage;
